import {getAuthInfo} from "../../../../utils/authUtils";

export type ButtonAction =
    | 'apply' | 'cancel' | 'cancelReservation'
    | 'confirmEnd' | 'requestEnd' | 'adjustDecision' | null;

export interface ButtonInfo { text: string; action: ButtonAction; }

export const useJobButtonInfo = (data: any): ButtonInfo => {
    if (!data) return { text: '버튼 없음', action: null };

    const auth = getAuthInfo();
    const isApplyCoordinator = auth && data.coordinatorApplies?.some(
        (a: any) => a.coordinatorCode === auth.coordinatorCode
    );
    const isMatchedCoordinator = auth && data.coordinatorCode === auth.coordinatorCode;

    if (data.coordinatorCode) sessionStorage.setItem('coordinatorCode', data.coordinatorCode);
    else sessionStorage.removeItem('coordinatorCode');

    let isOngoingAfterEnd: boolean;
    if (data.workType === 'HOURLY' && data.workEndTime) {
        const careEndDateTime = new Date(`${data.careEndDate}T${data.workEndTime}`);
        isOngoingAfterEnd = data.status === 'ONGOING' && careEndDateTime <= new Date();
    } else {
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const careEnd = new Date(data.careEndDate); careEnd.setHours(0, 0, 0, 0);
        isOngoingAfterEnd = data.status === 'ONGOING' && careEnd < today;
    }

    // 작성자
    if (data.isApplier) {
        if (data.status === 'RECRUITING') return { text: '공고취소', action: 'cancel' };
        if (data.status === 'MATCHED')    return { text: '예약취소', action: 'cancelReservation' };
        if (data.status === 'ONGOING' && isOngoingAfterEnd) {
            if (data.payOption === 'adjust' && data.isAdjustAccepted === null)
                return { text: '조정 승인|조정 거절', action: 'adjustDecision' };
            if (data.payOption !== 'adjust')
                return { text: '종료 확정', action: 'confirmEnd' };
        }
        return { text: '버튼 없음', action: null };
    }

    // 매칭 코디
    if (isMatchedCoordinator) {
        if (data.status === 'RECRUITING') return { text: '공고 지원', action: 'apply' };
        if (data.status === 'MATCHED')    return { text: '예약취소', action: 'cancelReservation' };
        if (data.status === 'ONGOING' && isOngoingAfterEnd) {
            if (data.isCoordinatorConfirm) {
                if (data.isAdjustAccepted === null)  return { text: '종료 확인 대기', action: null };
                if (data.isAdjustAccepted === true)  return { text: '버튼 없음', action: null };
                return { text: '종료 신청', action: 'requestEnd' };
            }
            return { text: '종료 신청', action: 'requestEnd' };
        }
        return { text: '버튼 없음', action: null };
    }

    // 지원 코디
    if (isApplyCoordinator && data.status === 'RECRUITING')
        return { text: '공고 지원 완료!\n다른 코디 매칭 시, 지원이 자동 취소됩니다.', action: null };

    // 일반 코디
    if (data.status === 'RECRUITING') return { text: '공고 지원', action: 'apply' };
    return { text: '버튼 없음', action: null };
};
